// Globals
import { useTranslation } from 'react-i18next';

// Permissions
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { Pagination } from '@/components';
import { Table } from '@/ui';
import RedirectsFiltersContainer from '../../containers/RedirectsFiltersContainer/RedirectsFiltersContainer';
import { StyledWrapper } from '../Styled';

// Models
import { IRedirect } from '@/models/redirects.model';

// Helpers
import { getRedirectsTableColumns } from './columns';

type TRedirectsListProps = {
  list: IRedirect[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onEdit: (item: IRedirect) => void;
  onDelete: (item: IRedirect) => void;
};

const RedirectsList = ({
  isLoading,
  list,
  total,
  currentPage,
  onPageChange,
  onEdit,
  onDelete,
}: TRedirectsListProps) => {
  const { t } = useTranslation(['redirects']);
  const { canManage } = usePermissions();

  return (
    <StyledWrapper>
      <Table
        columns={getRedirectsTableColumns({ t, onDelete, onEdit, canManage: canManage(Resource.SEO) })}
        loading={isLoading}
        dataSource={list}
        rowKey="id"
        scroll={{ x: 'max-content' }}
        components={{
          header: {
            wrapper: RedirectsFiltersContainer,
          },
        }}
      />
      <Pagination hideOnSinglePage current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default RedirectsList;
